var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightWhiteArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "63e992242d65538d958580f1_62e33ff5be01f764179d4f2f_Arrow%2520Right.svg.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6867 12.2089L13.5892 8.11139L14.6694 7.03125L20.6109 12.9728L14.6694 18.9143L13.5892 17.8342L17.6867 13.7367H3.45312V12.2089H17.6867Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightWhiteArrow);
export default __webpack_public_path__ + "static/media/right-white-arrow.a3c2af73692af8b95180bdd4e20d5400.svg";
export { ForwardRef as ReactComponent };